export default {
  title: 'Select the package that',
  title_light: ' suits you best!',
  description:
    'Save time and money through access to 100+ customised legal documents and unlimited phone consultations with specialized lawyers.'
};
